import { ExamsFilterDialog } from "components/ExamsFilterDialog";
import { useMemo } from "react";
import { useDialog } from "../DialogContext";
import type { DialogSpec, ShowExamsFilterOptions } from "../types";

export const examsFilterDialog: DialogSpec<"examsFilter"> = {
	render: ({ options, onClose }) => (
		<ExamsFilterDialog
			visible
			handleClose={onClose}
			postExamContextSwitchCallback={options.postExamContextSwitchCallback}
		/>
	),
	getMobileRoute: () => "/(protected)/exams",
};

export const useExamsFilterDialog = () => {
	const { showDialog, hideDialog } = useDialog();
	return useMemo(
		() => ({
			showExamsFilter: (options?: ShowExamsFilterOptions) =>
				showDialog("examsFilter", options ?? {}),
			hideExamsFilter: () => hideDialog("examsFilter"),
		}),
		[showDialog, hideDialog],
	);
};
